import type { FC } from 'react';

import { Typography } from 'enable-ui';

import { Header } from '../styles/dashboard';

import { COLOR_CONFIG } from 'constants/color';

export const CustomHeader: FC<{
  title?: string;
  styleHeader?: React.CSSProperties;
  id: string;
}> = ({ title, styleHeader, id }) => {
  return (
    <Header style={{ ...styleHeader }}>
      <div className="d-flex align-items-center">
        <Typography size={14} height={20} weight={600} color={COLOR_CONFIG['neutral-text']}>
          {title}
        </Typography>
      </div>
    </Header>
  );
};
